import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, $q, LocaleService, GeoCodeService, TranslateService, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);
    const newVehicle = {
        placeholder: true
    };

    ctrl.init = () => {
        $scope.claimVm = claimViewModel();
        $scope.vehicle = {
            selectedVehicle: null
        };

        if (!$scope.vehicleIncident) {
            if ($scope.claimVm.lobs.personalAuto.vehicleIncidents.length === 0) {
                $scope.claimVm.lobs.personalAuto.value.createVehicleIncident();
            }
            $scope.vehicleIncident = $scope.claimVm.lobs.personalAuto.vehicleIncidents.getElement(0);
        }
        $scope.theftCodes = {
            'theftentire': _.find($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'theftentire'
            }),
            'theftparts': _.find($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'theftparts'
            })
        };
        $scope.vehicleIncident.theft.value = _.values($scope.theftCodes).includes($scope.claimVm.lossCause.value);
        $scope.vehicleIncident.safeToDrive.value = false;
    };

    ctrl.defineWatches = () => {
        $scope.$watch('vehicle.selectedVehicle', (newValue, oldValue) => {
            if (newValue !== oldValue && newValue && newValue.placeholder) {
                $scope.vehicleIncident.value.setNewVehicle();
            } else {
                $scope.vehicleIncident.vehicle.value = newValue;
            }           
        });

        $scope.$watch('fnol.newMapCenter', (newCenter) => {
            if (newCenter !== undefined) {
                const result = GeoCodeService.getGeoCodedAddr(newCenter.latitude, newCenter.longitude);
                $q.when(result, (address) => {
                    $scope.claimVm.lossLocation.value = address;
                });
            }
        }, true);
    };

    ctrl.getAvailableVehicles = () => {
        const result = $scope.vehicleIncident.value.availableVehicles();
        result.push(newVehicle);
        return result;
    };

    ctrl.vehicleName = (vehicle) => {
        return vehicle.placeholder ?
            TranslateService.instant('fnol.pa.directives.vehicle-incident.Other Vehicle') :
            vehicle.getDisplayName(TranslateService.instant('fnol.pa.directives.vehicle-incident.New Vehicle'));
    };

    ctrl.next = (flowNextFn, form) => {
        if (form.invalid) {
            if ($scope.fnol.lossLocationType === 'map') {
                $scope.fnol.lossLocationType = 'city_only';
            }
        }
        changeEmptyToUndefined();
        return flowNextFn($scope.claimVm);
    };

    function changeEmptyToUndefined() {
        $scope.claimVm.lobs.personalAuto.vehicleIncidents.value.forEach((vehicleIncident) => {
            if (_.get(vehicleIncident.vehicle, 'vin') === '') {
                vehicleIncident.vehicle.vin = undefined;
            }
        });
    }

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$q', 'LocaleService', 'GeoCodeService', 'TranslateService', 'claimViewModel'];

export default fn;
